import { withAuthenticator } from '@aws-amplify/ui-react';
import App from './App';

export default withAuthenticator(App) ;